/*
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */

import * as coreHttp from "@azure/core-http";
import * as Models from "../models";
import * as Mappers from "../models/notificationsOperationsMappers";
import * as Parameters from "../models/parameters";
import { MicrosoftConsumerSecurityClientContext } from "../microsoftConsumerSecurityClientContext";

/** Class representing a NotificationsOperations. */
export class NotificationsOperations {
  private readonly client: MicrosoftConsumerSecurityClientContext;

  /**
   * Create a NotificationsOperations.
   * @param {MicrosoftConsumerSecurityClientContext} client Reference to the service client.
   */
  constructor(client: MicrosoftConsumerSecurityClientContext) {
    this.client = client;
  }

  /**
   * Calls Notification Hub to create or update installation
   * @summary Creates or updates a Notification Hub installation.
   * @param body
   * @param [options] The optional parameters
   * @returns Promise<coreHttp.RestResponse>
   */
  createOrUpdateInstallation(body: Models.DeviceInstallation, options?: coreHttp.RequestOptionsBase): Promise<coreHttp.RestResponse>;
  /**
   * @param body
   * @param callback The callback
   */
  createOrUpdateInstallation(body: Models.DeviceInstallation, callback: coreHttp.ServiceCallback<void>): void;
  /**
   * @param body
   * @param options The optional parameters
   * @param callback The callback
   */
  createOrUpdateInstallation(body: Models.DeviceInstallation, options: coreHttp.RequestOptionsBase, callback: coreHttp.ServiceCallback<void>): void;
  createOrUpdateInstallation(body: Models.DeviceInstallation, options?: coreHttp.RequestOptionsBase | coreHttp.ServiceCallback<void>, callback?: coreHttp.ServiceCallback<void>): Promise<coreHttp.RestResponse> {
    return this.client.sendOperationRequest(
      {
        body,
        options
      },
      createOrUpdateInstallationOperationSpec,
      callback);
  }

  /**
   * Calls Notification Hub to delete installation.
   * @summary Deletes a Notification Hub installation.
   * @param deviceId
   * @param [options] The optional parameters
   * @returns Promise<coreHttp.RestResponse>
   */
  deleteInstallation(deviceId: string, options?: coreHttp.RequestOptionsBase): Promise<coreHttp.RestResponse>;
  /**
   * @param deviceId
   * @param callback The callback
   */
  deleteInstallation(deviceId: string, callback: coreHttp.ServiceCallback<void>): void;
  /**
   * @param deviceId
   * @param options The optional parameters
   * @param callback The callback
   */
  deleteInstallation(deviceId: string, options: coreHttp.RequestOptionsBase, callback: coreHttp.ServiceCallback<void>): void;
  deleteInstallation(deviceId: string, options?: coreHttp.RequestOptionsBase | coreHttp.ServiceCallback<void>, callback?: coreHttp.ServiceCallback<void>): Promise<coreHttp.RestResponse> {
    return this.client.sendOperationRequest(
      {
        deviceId,
        options
      },
      deleteInstallationOperationSpec,
      callback);
  }
}

// Operation Specifications
const serializer = new coreHttp.Serializer(Mappers);
const createOrUpdateInstallationOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "POST",
  path: "api/v1/Notifications/installations",
  requestBody: {
    parameterPath: "body",
    mapper: {
      ...Mappers.DeviceInstallation,
      required: true
    }
  },
  contentType: "application/json-patch+json; charset=utf-8",
  responses: {
    200: {},
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const deleteInstallationOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "DELETE",
  path: "api/v1/Notifications/installations/{deviceId}",
  urlParameters: [
    Parameters.deviceId
  ],
  responses: {
    200: {},
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};
